// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"e25677c8","384":"7946ed65","802":"7946ed65","953":"81e290bc"}[chunkId] + ".chunk.css";
};